import React from "react";

const legacy = localStorage.getItem("legacy") === "true" ? true : false;
// const apiUrl = legacy ? "http://localhost:8081": "https://server.rhodesholidaysvillas.com";
const apiUrl = legacy? "https://rh-helpdesk-server.rhodesislandpass.com": "https://server.rhodesholidaysvillas.com";

export default apiUrl;
    